module.exports = __webpack_public_path__ + "img/hyper.c7099984.svg";